import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { palette, theme as colorTheme } from "../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;
const negativeBg = colorTheme('palette', 'negativeBg').value;

const SEVERITY_COLORS = {
  success: positive,
  error: negative,
  warning: "#F59E0B",
  info: primary,
};

const AutohideSnackbar = ({
  message,
  open,
  onClose,
  fileCount,
  severity = "info",
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MuiAlert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: "100%",
          bgcolor: SEVERITY_COLORS[severity] || primary,
          color: "#fff",
        }}
      >
        {message}
        {message === "Files uploaded successfully!" && fileCount > 0 && (
          <span style={{ marginLeft: "8px", fontWeight: 600 }}>
            ({fileCount} file{fileCount > 1 ? "s" : ""})
          </span>
        )}
      </MuiAlert>
    </Snackbar>
  );
};

export default AutohideSnackbar;
